<template>
    <v-card :loading="loading.services || loading.submitting">
        <v-snackbar :timeout="2000" color="error" v-model="error.invalidGrants">Le JSON de "grants" est invalide
        </v-snackbar>
        <v-form @submit.prevent="submit" autocomplete="off">
            <v-card-title>Ajouter une autorisations</v-card-title>
            <v-container>
                <v-select :items="servicesListSelect" :loading="loading.services" label="Service"
                          v-model="selectedService"/>
                <v-checkbox label="Pour une agence spécifique" v-model="branchScopeActive"/>
              <v-checkbox v-model="companyScopeActive" label="Pour la société spécifique"/>
              <v-text-field v-if="companyScopeActive" :disabled="!companyScopeActive" label="UUID Société"
                            v-model="companyScopeValue"/>
              <v-text-field :disabled="!branchScopeActive" label="UUID Agence" v-if="branchScopeActive"
              v-model="branchScopeValue"/>
            </v-container>
            <user-authorization-form :service="selectedService" v-model="authorization"/>

            <v-card-actions>
                <v-btn @click="cancel" text>Annuler</v-btn>
                <v-spacer/>
                <v-btn :loading="loading.submitting" color="primary" text type="submit">Sauvegarder</v-btn>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
import UserAuthorizationForm from "./UserAuthorizationForm";

export default {
		name: "AddUserAuthorizationForm",
		components: {UserAuthorizationForm},
		props: ['preselectedServiceName', 'user', 'servicesList', 'prefilledAuthorizationForm'],
		data() {
			return {
				servicesListSelect: [],
				selectedService: null,
				branchScopeValue: "",
				branchScopeActive: false,
				companyScopeValue: "",
				companyScopeActive: false,
				authorization: {
					role: "",
					grants: ""
				},
				loading: {
					services: false,
					submitting: false
				},
				error: { // TODO afficher les erreurs
					loadingServices: false,
					submitting: false,
					invalidGrants: false
				}
			}
		},
		watch: {
			preselectedServiceName(newVal) {
				this.preselectService(newVal);
			},
			prefilledAuthorizationForm: {
				handler: function (newVal) {
					this.preselectService(this.preselectedServiceName);
					this.authorization = newVal.authorization;

					this.branchScopeActive = newVal.scope.branchUuid !== "";
					this.companyScopeActive = newVal.scope.companyUuid !== "";
					this.branchScopeValue = !!newVal.scope.branchUuid ? newVal.scope.branchUuid : "";
					this.companyScopeValue = !!newVal.scope.companyUuid ? newVal.scope.companyUuid : "";
				},
				deep: true
			}
		},
		mounted() {
			for (let s of this.servicesList) {
				this.servicesListSelect.push({text: s.serviceName, value: s});
			}
			this.preselectService(this.preselectedServiceName);
		},
		methods: {
			preselectService(preselectedServiceName) {
				for (let s of this.servicesList) {
					if (s.serviceName === preselectedServiceName) {
						this.selectedService = s;
					}
				}
			},
			submit() {
				try {
					let scope = {};

					if (this.branchScopeActive) scope['branchUuid'] = this.branchScopeValue;
					else scope['branchUuid'] = "";

					if (this.companyScopeActive) scope['companyUuid'] = this.companyScopeValue;
					else scope['companyUuid'] = "";

					let newAuthor = {
						scope: scope,
						authorization: {
							role: this.authorization.role,
							grants: this.authorization.grants === "" ? {} : JSON.parse(this.authorization.grants)
						}
					};

					let currentAuthors = this.user.authorizations[this.selectedService.serviceName];
					if (!currentAuthors) {
						currentAuthors = [];
					}
					currentAuthors.push(newAuthor)

					this.loading.submitting = true;
					this.error.submitting = false;
					this.$http.put(this.$config.apiUrl + "/v2/users/" + this.user.id + "/services/" + this.selectedService.serviceName + "/authorizations", currentAuthors)
						.then(() => {
							this.resetForm();
							this.$emit('save')
						})
						.catch(() => this.error.submitting = true)
						.finally(() => this.loading.submitting = false);
				} catch (e) {
					this.error.invalidGrants = true;
				}
			},
			cancel() {
				this.$emit('cancel');
				this.resetForm();
			},
			resetForm() {
				this.branchScopeValue = "";
				this.branchScopeActive = false;
				this.companyScopeValue = "";
				this.companyScopeActive = false
				this.authorization = {
					role: "",
					grants: ""
				};
			}
		}


	}
</script>

<style scoped>

</style>
